import type { CustomQueryParams, SupportedQueryKey } from '../types';

/**
 * 路由命令前缀
 */
export const ROUTER_COMMAND_PREFIX = 'command:route:';

export const SUPPORTED_QUERY_LIST: SupportedQueryKey[] = [
    'taskId', 'task_id', 'shareId', 'share_id', 'tab', 'payment_state',
];


/**
 * 定义一个以 command:route: 为前缀的类型
 */
export type CommandRoutePrefix = `${typeof ROUTER_COMMAND_PREFIX}${string}`;

declare module '@patsnap/tahiti-core' {
    export interface CommandService {
        /**
         * 路由命令
         * @description 路由命令，用于跳转至指定路由
         * @param commandId 命令ID
         * @param params 参数
         */
        executeCommand(commandId: CommandRoutePrefix, params?: CustomQueryParams): void;
    }
}

